/* ============================================================
   STARKFELD Custom Buybox — behavior layer
   Custom elements survive ProductInfo section re-renders because
   connectedCallback re-runs whenever swapped HTML is adopted.

   <sf-offer-picker>  quantity tiers (Kaufe 1/2/3) + free gift
   <sf-bundle-picker> bundle-first variant selection (Starkboots)
   <sf-size-helper>   inline thigh/inseam size calculator (rules only in
                      assets/sf-size-engine.js, loaded on demand)
   <sf-box-builder>   pack-your-own 3-shaker box
   ============================================================ */
(function () {
  'use strict';

  /* Format money in the SHOP's configured format (theme.settings.moneyFormat,
     e.g. "€{{amount_with_comma_separator}}") so JS-rendered prices match the
     Liquid-rendered ones pixel for pixel. Intl fallback. */
  var intlFmt = null;
  function formatMoney(cents) {
    var fmt = window.theme && theme.settings && theme.settings.moneyFormat;
    if (fmt) {
      var noDecimals = fmt.indexOf('no_decimals') !== -1;
      var commaDecimal = fmt.indexOf('comma_separator') !== -1;
      var fixed = (cents / 100).toFixed(noDecimals ? 0 : 2);
      var parts = fixed.split('.');
      var thousands = commaDecimal ? '.' : ',';
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var value = parts[1] ? intPart + (commaDecimal ? ',' : '.') + parts[1] : intPart;
      return fmt.replace(/\{\{\s*[^}]+\s*\}\}/, value).replace(/<[^>]*>/g, '');
    }
    if (!intlFmt) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      intlFmt = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency
      });
    }
    return intlFmt.format(cents / 100);
  }

  function preserveWindowScroll(x, y, duration) {
    var until = Date.now() + (duration || 7200);
    var lock = {
      x: x,
      y: y,
      until: until
    };

    window.__sfBuyboxScrollLock = lock;
    window.__sfBuyboxPreventMediaScrollUntil = until;

    function cancelOnUserScroll() {
      if (window.__sfBuyboxScrollLock === lock) {
        window.__sfBuyboxScrollLock = null;
      }
    }

    function restore() {
      if (window.__sfBuyboxScrollLock !== lock || Date.now() > lock.until) return;
      window.scrollTo(lock.x, lock.y);
    }

    window.addEventListener('wheel', cancelOnUserScroll, { passive: true, once: true });
    window.addEventListener('touchstart', cancelOnUserScroll, { passive: true, once: true });
    window.addEventListener('keydown', cancelOnUserScroll, { passive: true, once: true });

    restore();
    requestAnimationFrame(restore);
    requestAnimationFrame(function () {
      requestAnimationFrame(restore);
    });

    [40, 80, 140, 220, 360, 540, 760, 1000, 1300, 1700, 2200, 2800, 3600, 4300, 5400, 6800, 7600].forEach(function (delay) {
      setTimeout(restore, delay);
    });
  }

  function extendWindowScrollLock(duration) {
    var lock = window.__sfBuyboxScrollLock;
    if (!lock || Date.now() > lock.until) return;
    preserveWindowScroll(lock.x, lock.y, duration || 4200);
  }

  function primeUnitOneScrollLock(event) {
    var target = event.target && event.target.closest ? event.target.closest('sf-offer-picker [data-sf-main-color], .sfb-size, [data-sf-sizes] label, .sfb-bundle') : null;
    if (!target) return;
    preserveWindowScroll(window.scrollX || window.pageXOffset || 0, window.scrollY || window.pageYOffset || 0, 7200);
  }

  document.addEventListener('pointerdown', primeUnitOneScrollLock, true);
  document.addEventListener('click', primeUnitOneScrollLock, true);

  /* ----------------------------------------------------------
     OFFER PICKER
     - keeps a hidden quantity input on the product form in sync
     - toggles the hidden gift checkbox (name="bundles") for the
       gift tier so the direct-checkout permalink includes it
     - re-renders tier prices when the variant price changes
     ---------------------------------------------------------- */
  if (!customElements.get('sf-offer-picker')) {
    customElements.define('sf-offer-picker', class extends HTMLElement {
      connectedCallback() {
        this.formId = this.getAttribute('form');
        this.unitPrice = parseInt(this.getAttribute('data-unit-price'), 10) || 0;
        this.unitCompare = parseInt(this.getAttribute('data-unit-compare'), 10) || 0;
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.form = document.getElementById(this.formId);
        (this.form || document).addEventListener('variant:change', this.onVariantChange);
        this.renderPrices();
        this.initializeUnitRows();
        this.enhanceCheckoutButton();
        this.syncForm();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        (this.form || document).removeEventListener('variant:change', this.onVariantChange);
      }

      get selectedTier() {
        return this.querySelector('input[name^="sf-offer"]:checked');
      }

      get qtyInput() {
        return document.querySelector('input[name="quantity"][data-sf-offer-qty][form="' + this.formId + '"]');
      }

      get itemsInput() {
        return document.querySelector('input[name="sf_items"][data-sf-offer-items][form="' + this.formId + '"]');
      }

      get giftInput() {
        return document.querySelector('input[name="bundles"][data-sf-offer-gift][form="' + this.formId + '"]');
      }

      get discountInput() {
        return document.querySelector('input[name="sf_discount"][form="' + this.formId + '"]');
      }

      get mainVariantId() {
        var form = document.getElementById(this.formId);
        var idInput = form && form.querySelector('input[name="id"]');
        return idInput ? idInput.value : null;
      }

      enhanceCheckoutButton() {
        var form = document.getElementById(this.formId);
        var button = form && form.querySelector('button[type="submit"][name="add"], .product-form__submit');
        if (button) button.classList.add('sfb-checkout-cta');
      }

      get colorOptionIndex() {
        return this.getAttribute('data-color-option-index') || '';
      }

      get productScope() {
        return this.closest('product-info, .product-info, [data-section]') || document;
      }

      currentMainColor() {
        var index = this.colorOptionIndex;
        var scope = this.productScope;
        var inputs = scope.querySelectorAll('variant-picker input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if (String(inputs[i].getAttribute('data-option-index')) === String(index) && inputs[i].checked) {
            return inputs[i].getAttribute('data-option-value') || inputs[i].value || '';
          }
        }
        return '';
      }

      initializeUnitRows() {
        var mainColor = this.currentMainColor();
        var self = this;
        this.querySelectorAll('[data-sf-unit-row]').forEach(function (row) {
          var unit = parseInt(row.getAttribute('data-sf-unit-row'), 10) || 1;
          var button = self.findColorButton(row, mainColor) || row.querySelector('[data-sf-unit-button]');
          if (!button) return;
          self.selectUnitButton(button, { silent: true, touched: false });
          if (unit === 1) row.removeAttribute('data-sf-touched');
        });
      }

      findColorButton(row, color) {
        var buttons = row ? row.querySelectorAll('[data-sf-unit-button]') : [];
        for (var i = 0; i < buttons.length; i++) {
          if (buttons[i].getAttribute('data-color') === color) return buttons[i];
        }
        return null;
      }

      selectMainColor(button) {
        var scrollX = window.scrollX || window.pageXOffset || 0;
        var scrollY = window.scrollY || window.pageYOffset || 0;
        var color = button.getAttribute('data-color') || '';
        var index = this.colorOptionIndex;
        var scope = this.productScope;
        var inputs = scope.querySelectorAll('variant-picker input[type="radio"]');
        var target = null;
        for (var i = 0; i < inputs.length; i++) {
          var sameOption = String(inputs[i].getAttribute('data-option-index')) === String(index);
          var sameColor = (inputs[i].getAttribute('data-option-value') || inputs[i].value) === color;
          if (sameOption && sameColor) {
            target = inputs[i];
            break;
          }
        }
        if (target && !target.checked) {
          preserveWindowScroll(scrollX, scrollY, 7200);
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
          preserveWindowScroll(scrollX, scrollY, 7200);
        }
        this.syncMainColorButtons(color);
        this.composeItems();
      }

      selectUnitButton(button, options) {
        options = options || {};
        var row = button.closest('[data-sf-unit-row]');
        if (!row) return;
        var color = button.getAttribute('data-color') || '';
        var variantId = button.getAttribute('data-variant-id') || '';
        row.setAttribute('data-sf-variant-id', variantId);
        row.setAttribute('data-sf-color', color);
        if (options.touched) row.setAttribute('data-sf-touched', 'true');
        row.querySelectorAll('[data-sf-unit-button]').forEach(function (btn) {
          var selected = btn === button;
          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        var unit = row.getAttribute('data-sf-unit-row');
        var label = row.querySelector('[data-sf-unit-color="' + unit + '"]');
        if (label) label.textContent = color;
        if (!options.silent) this.composeItems();
      }

      syncMainColorButtons(color) {
        var self = this;
        this.querySelectorAll('[data-sf-unit-row="1"]').forEach(function (row) {
          var match = self.findColorButton(row, color);
          if (match) self.selectUnitButton(match, { silent: true, touched: false });
        });
      }

      onClick(e) {
        var button = e.target.closest('[data-sf-unit-button]');
        if (!button || !this.contains(button)) return;
        e.preventDefault();
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        var row = button.closest('[data-sf-unit-row]');
        var unit = row ? parseInt(row.getAttribute('data-sf-unit-row'), 10) || 1 : 1;
        if (unit === 1 || button.hasAttribute('data-sf-main-color')) {
          this.selectMainColor(button);
          return;
        }
        this.selectUnitButton(button, { touched: true });
      }

      onChange(e) {
        var name = e.target.name || '';
        if (name.indexOf('sf-offer') === 0) {
          this.syncForm();
          return;
        }
        if (name.indexOf('sf-unit') === 0) {
          if (e.isTrusted !== false) {
            this.touched = this.touched || {};
            this.touched[name] = true;
          }
          this.updateUnitColorLabel(e.target);
          this.composeItems();
        }
      }

      onVariantChange(e) {
        var variant = e.detail && e.detail.variant;
        if (!variant) return;
        extendWindowScrollLock(4200);
        this.unitPrice = variant.price;
        this.unitCompare = variant.compare_at_price || 0;
        this.followMainColor(variant);
        this.renderPrices();
        this.composeItems();
        extendWindowScrollLock(4200);
      }

      /* Units the buyer never touched follow the main color choice,
         so "3x in grey" needs exactly one click. Explicit unit picks
         stay untouched. */
      followMainColor(variant) {
        var self = this;
        var color = '';
        var buttons = this.querySelectorAll('[data-sf-unit-button]');
        if (variant.options) {
          for (var i = 0; i < buttons.length; i++) {
            var buttonColor = buttons[i].getAttribute('data-color');
            if (variant.options.indexOf(buttonColor) !== -1) {
              color = buttonColor;
              break;
            }
          }
        }
        if (!color) color = this.currentMainColor();
        if (!color) return;

        this.syncMainColorButtons(color);
        this.querySelectorAll('[data-sf-unit-row]').forEach(function (row) {
          var unit = parseInt(row.getAttribute('data-sf-unit-row'), 10) || 1;
          if (unit === 1 || row.getAttribute('data-sf-touched') === 'true') return;
          var match = self.findColorButton(row, color);
          if (match) self.selectUnitButton(match, { silent: true, touched: false });
        });
      }

      updateUnitColorLabel(input) {
        var unit = input.getAttribute('data-sf-unit');
        var row = input.closest('.sfb-units__row');
        var label = row && row.querySelector('[data-sf-unit-color="' + unit + '"]');
        if (label) label.textContent = input.getAttribute('data-color') || '';
      }

      /* Build "ID:QTY,ID:QTY" for mixed-color multi-packs. Unit 1 is
         the main variant picker; units 2..n have their own swatches.
         Empty for single-unit tiers (interceptor falls back to id:qty). */
      composeItems() {
        var itemsInput = this.itemsInput;
        if (!itemsInput) return;
        var tier = this.selectedTier;
        var qty = tier ? parseInt(tier.getAttribute('data-qty'), 10) || 1 : 1;
        var mainId = this.mainVariantId;
        if (qty <= 1 || !mainId) {
          itemsInput.value = '';
          return;
        }
        var counts = {};
        counts[mainId] = 1;
        var tierWrap = tier.closest('.sfb-offer');
        var unitRows = tierWrap ? tierWrap.querySelectorAll('[data-sf-unit-row]') : [];
        for (var i = 0; i < unitRows.length; i++) {
          var unit = parseInt(unitRows[i].getAttribute('data-sf-unit-row'), 10) || 1;
          if (unit <= 1 || unit > qty) continue;
          var id = unitRows[i].getAttribute('data-sf-variant-id');
          if (!id) continue;
          counts[id] = (counts[id] || 0) + 1;
        }
        // fewer unit rows than expected (e.g. missing selection) -> top up with main color
        var total = Object.keys(counts).reduce(function (sum, k) { return sum + counts[k]; }, 0);
        if (total < qty && this.form?.querySelector('[data-stl-preorder-route]')) {
          itemsInput.value = 'invalid';
          return;
        }
        if (total < qty) counts[mainId] += qty - total;
        itemsInput.value = Object.keys(counts).map(function (id) { return id + ':' + counts[id]; }).join(',');
      }

      syncForm() {
        var tier = this.selectedTier;
        if (!tier) return;
        var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var hasGift = tier.getAttribute('data-gift') === 'true';
        var code = tier.getAttribute('data-code') || '';

        var qtyInput = this.qtyInput;
        if (qtyInput && qtyInput.value !== String(qty)) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var giftInput = this.giftInput;
        if (giftInput) giftInput.checked = hasGift;
        var discountInput = this.discountInput;
        if (discountInput) discountInput.value = code;
        this.composeItems();
      }

      renderPrices() {
        var self = this;
        this.querySelectorAll('.sfb-offer').forEach(function (offer) {
          var input = offer.querySelector('input');
          if (!input) return;
          var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(input.getAttribute('data-discount')) || 0;
          var base = self.unitPrice * qty;
          // Kaufe 3 with gift is an order-level code (it must coexist with the gift BXGY), so Shopify rounds the total there.
          var orderLevel = input.getAttribute('data-gift') === 'true' && !self.form?.querySelector('[data-stl-preorder-route]');
          var now = orderLevel
            ? Math.round(base * (1 - pct / 100))
            : (self.unitPrice - Math.floor(self.unitPrice * pct / 100)) * qty;
          var nowEl = offer.querySelector('[data-price-now]');
          var wasEl = offer.querySelector('[data-price-was]');
          var unitEl = offer.querySelector('[data-price-unit]');
          if (nowEl) nowEl.textContent = formatMoney(now);
          if (wasEl) {
            if (pct > 0) {
              wasEl.textContent = formatMoney(base);
              wasEl.hidden = false;
            } else if (self.unitCompare > self.unitPrice) {
              wasEl.textContent = formatMoney(self.unitCompare * qty);
              wasEl.hidden = false;
            } else {
              wasEl.hidden = true;
            }
          }
          if (unitEl && qty > 1) {
            unitEl.textContent = formatMoney(Math.round(now / qty)) + unitEl.getAttribute('data-unit-label');
            unitEl.hidden = false;
          } else if (unitEl) {
            unitEl.hidden = true;
          }
        });
      }
    });
  }

  /* ----------------------------------------------------------
     BUNDLE PICKER (lives inside <variant-picker>)
     Fieldsets are rendered in option order (size first in DOM,
     visually reordered with CSS order). When the bundle changes
     we fix up the size selection *before* the change event
     reaches <variant-picker> (capture phase), so the published
     option ids always describe a real variant.
     ---------------------------------------------------------- */
  if (!customElements.get('sf-bundle-picker')) {
    customElements.define('sf-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        this.onBundleChange = this.onBundleChange.bind(this);
        this.addEventListener('change', this.onBundleChange, true);
        this.refreshSizeState(false);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onBundleChange, true);
      }

      onBundleChange(e) {
        if (!e.target.matches('[data-sf-bundle-input]')) return;
        this.refreshSizeState(true);
      }

      refreshSizeState(fixSelection) {
        var bundle = this.querySelector('[data-sf-bundle-input]:checked');
        var sizeFieldset = this.querySelector('[data-sf-sizes]');
        if (!bundle || !sizeFieldset) return;

        var exists = (bundle.getAttribute('data-size-exists') || '').split('|').filter(Boolean);
        var available = (bundle.getAttribute('data-size-values') || '').split('|').filter(Boolean);
        var sized = bundle.getAttribute('data-sized') === 'true';
        var inputs = Array.prototype.slice.call(sizeFieldset.querySelectorAll('input[type="radio"]'));

        inputs.forEach(function (input) {
          var label = input.closest('.sfb-size');
          var doesExist = exists.indexOf(input.value) !== -1;
          var isAvailable = available.indexOf(input.value) !== -1;
          if (label) label.style.display = doesExist ? '' : 'none';
          input.classList.toggle('disabled', !isAvailable);
          input.toggleAttribute('data-sf-unavailable', !isAvailable);
        });

        // hide entire size group (and helper/table links) for unisize bundles
        sizeFieldset.toggleAttribute('hidden', !sized);
        var blockRoot = this.closest('[data-sf-bundle-block]');
        var extras = blockRoot && blockRoot.querySelector('[data-sf-size-extras]');
        if (extras) extras.toggleAttribute('hidden', !sized);

        if (fixSelection) {
          var checked = sizeFieldset.querySelector('input[type="radio"]:checked');
          if (!checked || available.indexOf(checked.value) === -1) {
            var first = inputs.filter(function (i) { return available.indexOf(i.value) !== -1; })[0];
            if (first) first.checked = true;
          }
        }
      }
    });
  }

  /* ----------------------------------------------------------
     SIZE HELPER — rechnet ausschliesslich mit assets/sf-size-engine.js
     (einzige Quelle der Groessenregeln, 24.09.2026). Seiten, die das
     Engine-Skript nicht selbst einbinden (aeltere Picker-Kopien), laden es
     beim ersten Rechnen aus demselben Asset-Ordner wie diese Datei nach.
     ---------------------------------------------------------- */
  var SIZE_ENGINE_SRC = (function () {
    var cs = document.currentScript;
    return cs && cs.src ? cs.src.replace(/sf-buybox\.js(\?[^#]*)?/, 'sf-size-engine.js') : '';
  })();

  function withSizeEngine(cb) {
    if (window.SFSizeEngine) return cb(window.SFSizeEngine);
    (window.__sfSizeEngineQueue = window.__sfSizeEngineQueue || []).push(cb);
    if (window.__sfSizeEngineLoading || !SIZE_ENGINE_SRC || document.querySelector('script[src*="sf-size-engine.js"]')) return;
    window.__sfSizeEngineLoading = true;
    var tag = document.createElement('script');
    tag.src = SIZE_ENGINE_SRC;
    document.head.appendChild(tag);
  }

  if (!customElements.get('sf-size-helper')) {
    customElements.define('sf-size-helper', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-sf-helper-toggle]');
        this.panel = this.querySelector('[data-sf-helper-panel]');
        this.thigh = this.querySelector('[data-sf-helper-thigh]');
        this.inseam = this.querySelector('[data-sf-helper-inseam]');
        this.result = this.querySelector('[data-sf-helper-result]');
        this.sizeEl = this.querySelector('[data-sf-helper-size]');
        this.textEl = this.querySelector('[data-sf-helper-text]');
        this.applyBtn = this.querySelector('[data-sf-helper-apply]');

        this.onToggle = this.onToggle.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onApply = this.onApply.bind(this);
        if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
        if (this.thigh) this.thigh.addEventListener('input', this.onInput);
        if (this.inseam) this.inseam.addEventListener('input', this.onInput);
        if (this.applyBtn) this.applyBtn.addEventListener('click', this.onApply);
      }

      disconnectedCallback() {
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        if (this.thigh) this.thigh.removeEventListener('input', this.onInput);
        if (this.inseam) this.inseam.removeEventListener('input', this.onInput);
        if (this.applyBtn) this.applyBtn.removeEventListener('click', this.onApply);
      }

      onToggle() {
        var hidden = this.panel.hasAttribute('hidden');
        this.panel.toggleAttribute('hidden', !hidden);
        this.toggle.setAttribute('aria-expanded', hidden ? 'true' : 'false');
        if (hidden && this.thigh) this.thigh.focus();
      }

      onInput() {
        var self = this;
        withSizeEngine(function (E) {
          var th = E.parse(self.thigh.value);
          var ins = E.parse(self.inseam.value);
          var L = E.LIMITS;
          if (!(th >= L.thigh.min && th <= L.thigh.max) || !(ins >= L.inseam.min && ins <= L.inseam.max)) {
            self.recommended = null;
            self.result.hidden = true;
            return;
          }
          var r = E.recommend({ thigh: th, inseam: ins });
          var usable = r.size && r.confidence !== 'none';
          var notes = r.warnings.filter(function (w) { return w.code !== 'contact'; }).map(function (w) { return w.text; }).join(' ');
          self.recommended = usable ? r.size : null;
          self.sizeEl.textContent = r.size || '–';
          self.textEl.textContent = r.title + '. ' + r.summary + (notes ? ' ' + notes : '');
          if (self.applyBtn) {
            self.applyBtn.hidden = !usable;
            self.applyBtn.textContent = usable ? 'Größe ' + r.size + ' übernehmen' : 'Übernehmen';
          }
          self.result.hidden = false;
          self.result.classList.add('sfb-helper__result--ok');
        });
      }

      onApply() {
        if (!this.recommended) return;
        var scope = this.closest('.product-info, product-info') || document;
        var sizeFieldset = scope.querySelector('[data-sf-sizes]') || scope;
        var target = null;
        sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = (input.getAttribute('data-size-letter') || input.value || '').toUpperCase();
          if (!target && (label === this.recommended || label.charAt(0) === this.recommended)) target = input;
        }, this);
        if (target && !target.checked && !target.classList.contains('disabled')) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  /* ----------------------------------------------------------
     KIT UPSELL MODAL — click-triggered on the checkout button.
     Boots-only -> pitch the kit (size already known).
     Sleeves/Hips-only -> pitch the kit (asks for a size; the
     attachments need the boots' Smart Monitor anyway).
     Declines remembered per session, Esc/outside just closes.
     ---------------------------------------------------------- */
  if (!customElements.get('sf-upsell-modal')) {
    customElements.define('sf-upsell-modal', class extends HTMLElement {
      connectedCallback() {
        this.formId = this.getAttribute('form');
        this.kitMatch = this.getAttribute('data-kit-match');
        this.kitPrice = parseInt(this.getAttribute('data-kit-price'), 10) || 0;
        this.kitSaving = parseInt(this.getAttribute('data-kit-saving'), 10) || 0;
        this.discountCode = this.getAttribute('data-discount-code') || '';
        try {
          this.kitSizes = JSON.parse(this.querySelector('[data-sfu-kit-sizes]').textContent);
        } catch (err) {
          this.kitSizes = {};
        }
        this.chosenSize = null;
        this.onDocClick = this.onDocClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        document.addEventListener('click', this.onDocClick, true);

        var self = this;
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-sfu-close]')) self.hide();
          if (e.target.closest('[data-sfu-decline]')) self.decline();
          if (e.target.closest('[data-sfu-accept]')) self.accept();
          var sizeBtn = e.target.closest('[data-sfu-size]');
          if (sizeBtn) self.pickSize(sizeBtn);
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick, true);
        document.removeEventListener('keydown', this.onKeydown);
      }

      get bundleValue() {
        var scope = this.closest('[data-sf-bundle-block]') || document;
        var checked = scope.querySelector('[data-sf-bundle-input]:checked');
        return checked ? checked.value : null;
      }

      get sizeValue() {
        var scope = this.closest('[data-sf-bundle-block]') || document;
        var checked = scope.querySelector('[data-sf-sizes] input:checked');
        return checked ? checked.value : null;
      }

      modeFor(bundle) {
        if (!bundle || bundle === this.kitMatch) return null;
        var sized = false;
        var scope = this.closest('[data-sf-bundle-block]') || document;
        var input = scope.querySelector('[data-sf-bundle-input]:checked');
        if (input) sized = input.getAttribute('data-sized') === 'true';
        return sized ? 'boots' : 'attachment';
      }

      onDocClick(e) {
        var btn = e.target.closest('button[type="submit"], button[name="add"]');
        if (!btn) return;
        var formId = btn.getAttribute('form') || (btn.form && btn.form.getAttribute('id'));
        if (formId !== this.formId) return;
        if (this._allow) { this._allow = false; return; }

        var mode = this.modeFor(this.bundleValue);
        if (!mode) return;
        if (sessionStorage.getItem('sf-upsell-seen-' + mode)) return;

        e.preventDefault();
        e.stopPropagation();
        this._submitter = btn;
        this.show(mode);
      }

      show(mode) {
        this.mode = mode;
        this.querySelectorAll('[data-sfu-mode]').forEach(function (el) {
          el.hidden = el.getAttribute('data-sfu-mode') !== mode;
        });

        // savings + price
        var savingEl = this.querySelector('[data-sfu-saving]');
        if (savingEl) savingEl.textContent = formatMoney(this.kitSaving);
        var priceEl = this.querySelector('[data-sfu-kit-price]');
        if (priceEl) priceEl.textContent = ' – ' + formatMoney(this.kitPrice);

        // size handling: boots mode reuses the chosen size when the kit
        // has it in stock; otherwise (or in attachment mode) show chips
        var sizesWrap = this.querySelector('[data-sfu-sizes]');
        var currentSize = this.sizeValue;
        var kitHasCurrent = mode === 'boots' && currentSize && this.kitSizes[currentSize] && this.kitSizes[currentSize].available;
        if (kitHasCurrent) {
          this.chosenSize = currentSize;
          sizesWrap.hidden = true;
        } else {
          this.renderSizeChips(sizesWrap);
          sizesWrap.hidden = false;
        }

        this.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
        var cta = this.querySelector('[data-sfu-accept]');
        if (cta) cta.focus({ preventScroll: true });
      }

      renderSizeChips(wrap) {
        var row = wrap.querySelector('[data-sfu-sizes-row]');
        var self = this;
        row.innerHTML = '';
        this.chosenSize = null;
        Object.keys(this.kitSizes).forEach(function (size) {
          if (!self.kitSizes[size].available) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sfu__size';
          btn.setAttribute('data-sfu-size', size);
          btn.textContent = size === 'Unisize' ? size : size.charAt(0).toUpperCase();
          btn.title = size;
          row.appendChild(btn);
          // sensible default: current selection if kit has it, else Medium, else first
          if (!self.chosenSize && (size === self.sizeValue || size === 'Medium')) {
            self.pickSize(btn);
          }
        });
        if (!this.chosenSize) {
          var first = row.querySelector('[data-sfu-size]');
          if (first) this.pickSize(first);
        }
      }

      pickSize(btn) {
        this.chosenSize = btn.getAttribute('data-sfu-size');
        this.querySelectorAll('[data-sfu-size]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      }

      onKeydown(e) {
        if (e.key === 'Escape') this.hide();
      }

      hide() {
        this.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
        if (this.mode) sessionStorage.setItem('sf-upsell-seen-' + this.mode, '1');
      }

      decline() {
        this.hide();
        if (this._submitter) {
          this._allow = true;
          this._submitter.click();
        }
      }

      accept() {
        var size = this.chosenSize;
        var entry = size && this.kitSizes[size];
        if (!entry || !entry.available) return;
        var url = '/cart/' + entry.id + ':1';
        if (this.discountCode) url += '?discount=' + encodeURIComponent(this.discountCode);
        var cta = this.querySelector('[data-sfu-accept]');
        if (cta) cta.setAttribute('aria-busy', 'true');
        try { if (window.sbxDecoratePermalink) url = window.sbxDecoratePermalink(url); } catch (sbxErr) {}
        window.location.href = url;
      }
    });
  }

  /* ----------------------------------------------------------
     BOX BUILDER — three shaker slots, color per slot,
     checkout via cart permalink (aggregated quantities).
     ---------------------------------------------------------- */
  if (!customElements.get('sf-box-builder')) {
    customElements.define('sf-box-builder', class extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-sfbx-variants]').textContent);
        } catch (err) {
          this.variants = [];
        }
        this.discountCode = this.getAttribute('data-discount-code') || '';
        this.discountPct = parseFloat(this.getAttribute('data-discount-percent')) || 0;
        this.cta = this.querySelector('[data-sfbx-cta]');
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('change', this.onChange);
        if (this.cta) this.cta.addEventListener('click', this.onSubmit);
        this.update(false);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        if (this.cta) this.cta.removeEventListener('click', this.onSubmit);
      }

      variantById(id) {
        for (var i = 0; i < this.variants.length; i++) {
          if (String(this.variants[i].id) === String(id)) return this.variants[i];
        }
        return null;
      }

      slotSelections() {
        var picks = [];
        this.querySelectorAll('[data-sfbx-slot]').forEach(function (slot) {
          var checked = slot.querySelector('input:checked');
          picks.push(checked ? checked.value : null);
        });
        return picks;
      }

      onChange(e) {
        if (!e.target.matches('[data-sfbx-slot] input')) return;
        var slot = e.target.closest('[data-sfbx-slot]');
        this.update(true, slot ? slot.getAttribute('data-sfbx-slot') : null);
      }

      update(animate, changedIndex) {
        var picks = this.slotSelections();
        var self = this;
        var total = 0;
        var done = 0;

        picks.forEach(function (id, i) {
          var slot = self.querySelector('[data-sfbx-slot="' + i + '"]');
          var visual = self.querySelector('[data-sfbx-visual="' + i + '"]');
          var variant = id ? self.variantById(id) : null;
          if (slot) {
            slot.classList.toggle('is-done', !!variant);
            var colorEl = slot.querySelector('[data-sfbx-slot-color]');
            if (colorEl) colorEl.textContent = variant ? variant.color : '';
          }
          if (visual) {
            if (variant) {
              visual.classList.remove('sfbx__slot-visual--empty');
              var img = visual.querySelector('img');
              if (!img) {
                visual.innerHTML = '';
                img = document.createElement('img');
                img.alt = variant.title;
                img.loading = 'lazy';
                img.width = 360;
                img.height = 360;
                visual.appendChild(img);
              }
              var src = variant.image;
              if (img.getAttribute('src') !== src) {
                img.src = src;
                img.alt = variant.title;
                if (animate && String(changedIndex) === String(i)) {
                  visual.classList.remove('sfbx__slot-visual--pop');
                  void visual.offsetWidth;
                  visual.classList.add('sfbx__slot-visual--pop');
                }
              }
            }
          }
          if (variant) {
            total += variant.price;
            done++;
          }
        });

        // progress dashes
        this.querySelectorAll('.sfbx__counter i').forEach(function (bar, i) {
          bar.classList.toggle('is-filled', i < done);
        });

        var nowEl = this.querySelector('[data-sfbx-price-now]');
        var wasEl = this.querySelector('[data-sfbx-price-was]');
        var saveEl = this.querySelector('[data-sfbx-save]');
        var discounted = Math.round(total * (1 - this.discountPct / 100));
        if (nowEl) nowEl.textContent = formatMoney(discounted);
        if (wasEl) {
          wasEl.hidden = !(this.discountPct > 0 && total > 0);
          if (!wasEl.hidden) wasEl.textContent = formatMoney(total);
        }
        if (saveEl) {
          saveEl.hidden = !(this.discountPct > 0 && total > 0);
          if (!saveEl.hidden) saveEl.textContent = '−' + this.discountPct + '%';
        }

        if (this.cta) {
          this.cta.disabled = done < picks.length || picks.length === 0;
        }
        var hint = this.querySelector('[data-sfbx-hint]');
        if (hint) {
          var remaining = picks.length - done;
          hint.textContent = remaining > 0
            ? (remaining === 1 ? 'Noch 1 Farbe wählen' : 'Noch ' + remaining + ' Farben wählen')
            : hint.getAttribute('data-ready-text');
        }
      }

      onSubmit() {
        var picks = this.slotSelections();
        if (picks.indexOf(null) !== -1) return;
        var counts = {};
        picks.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) { return id + ':' + counts[id]; }).join(',');
        var gift = this.getAttribute('data-gift-variant');
        if (gift) items += ',' + gift + ':1';
        var url = '/cart/' + items;
        if (this.discountCode) url += '?discount=' + encodeURIComponent(this.discountCode);
        this.cta.setAttribute('aria-busy', 'true');
        try { if (window.sbxDecoratePermalink) url = window.sbxDecoratePermalink(url); } catch (sbxErr) {}
        window.location.href = url;
      }
    });
  }
})();
